var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgProductIconFilled = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3333 13.6663H0.666667C0.489856 13.6663 0.320286 13.5961 0.195262 13.4711C0.0702379 13.3461 0 13.1765 0 12.9997V0.999674C0 0.822863 0.0702379 0.653294 0.195262 0.52827C0.320286 0.403246 0.489856 0.333008 0.666667 0.333008H11.3333C11.5101 0.333008 11.6797 0.403246 11.8047 0.52827C11.9298 0.653294 12 0.822863 12 0.999674V12.9997C12 13.1765 11.9298 13.3461 11.8047 13.4711C11.6797 13.5961 11.5101 13.6663 11.3333 13.6663ZM4 2.99967H2.66667V4.33301C2.66667 5.21706 3.01786 6.06491 3.64298 6.69003C4.2681 7.31515 5.11595 7.66634 6 7.66634C6.88406 7.66634 7.7319 7.31515 8.35702 6.69003C8.98214 6.06491 9.33333 5.21706 9.33333 4.33301V2.99967H8V4.33301C8 4.86344 7.78929 5.37215 7.41421 5.74722C7.03914 6.12229 6.53043 6.33301 6 6.33301C5.46957 6.33301 4.96086 6.12229 4.58579 5.74722C4.21071 5.37215 4 4.86344 4 4.33301V2.99967Z",
    fill: "#6C7E8E"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgProductIconFilled, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ProductIconFilled.aee84704.svg";
export { ForwardRef as ReactComponent };